<template>
  <div class="inner-wrap">
    <div class="title">
      <h3>경기 주요 정보</h3>
    </div>
    <div class="content result-content">
      <div class="team-comparison-area">
        <div class="team-comparison-wrap">
          <!--홈팀-->
          <div class="team-comparison">
            <div class="left-area">
              <div class="team-logo">
                <img :src="awayTeamImage" :alt="awayTeamName + '로고'">
              </div>
              <div class="team-name">
                <h4>{{awayTeamName}}</h4>
              </div>
            </div>
            <div class="right-area">
              <!--안타 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>안타</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap">
                        <span class="graph-number">{{aHit}}</span>
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(aHit, hHit)+'%'}">{{aHit}}</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/안타 테이블-->

              <!--홈런 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>홈런</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap">
                        <span class="graph-number">{{aHr}}</span>
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(aHr, hHr)+'%'}">{{aHr}}</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/홈런 테이블-->

              <!--도루 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>도루</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap">
                        <span class="graph-number">{{aSb}}</span>
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(aSb, hSb)+'%'}">{{aSb}}</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/도루 테이블-->

              <!--삼진 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>삼진</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap">
                        <span class="graph-number">{{aKk}}</span>
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(aKk, hKk)+'%'}">{{aKk}}</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/삼진 테이블-->

              <!--병살 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>병살</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap">
                        <span class="graph-number">{{aGd}}</span>
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(aGd, hGd)+'%'}">{{aGd}}</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/병살 테이블-->

              <!--실책 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>실책</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap">
                        <span class="graph-number">{{aErr}}</span>
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(aErr, hErr)+'%'}">{{aErr}}</span>
                        </span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/실책 테이블-->
            </div>
          </div>
          <!--/홈팀-->
          <!--어웨이팀-->
          <div class="team-comparison">
            <div class="left-area">
              <div class="team-logo">
                <img :src="homeTeamImage" :alt="homeTeamName + '로고'">
              </div>
              <div class="team-name">
                <h4>{{homeTeamName}}</h4>
              </div>
            </div>
            <div class="right-area">
              <!--안타 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>안타</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap graph-away">
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(hHit, aHit)+'%'}">{{hHit}}</span>
                        </span>
                        <span class="graph-number">{{hHit}}</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/안타 테이블-->

              <!--홈런 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>홈런</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap graph-away">
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(hHr, aHr)+'%'}">{{hHr}}</span>
                        </span>
                        <span class="graph-number">{{hHr}}</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/홈런 테이블-->

              <!--도루 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>도루</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap graph-away">
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(hSb, aSb)+'%'}">{{hSb}}</span>
                        </span>
                        <span class="graph-number">{{hSb}}</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/도루 테이블-->

              <!--삼진 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>삼진</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap graph-away">
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(hKk, aKk)+'%'}">{{hSb}}>{{hKk}}</span>
                        </span>
                        <span class="graph-number">{{hKk}}</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/삼진 테이블-->

              <!--병살 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>병살</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap graph-away">
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(hGd, aGd)+'%'}">{{hGd}}</span>
                        </span>
                        <span class="graph-number">{{hGd}}</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/병살 테이블-->

              <!--실책 테이블-->
              <div class="comparison-table-wrap">
                <table class="comparison-table">
                  <caption>실책</caption>
                  <tbody>
                  <tr>
                    <td>
                      <div class="graph-wrap graph-away">
                        <span class="graph-outer">
                          <span class="graph-inner" :style="{width:graphPer(hErr, aErr)+'%'}">{{hErr}}</span>
                        </span>
                        <span class="graph-number">{{hErr}}</span>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!--/실책 테이블-->
            </div>
          </div>
          <!--/어웨이팀-->
        </div>
      </div>
      <div class="game-summary-area">
        <ul>
          <li v-for="(text, index) in textList" :key="index">{{text}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  export default {
    name: 'GameImportantInformation',
    props: {
      gameSummary: {
        type: Object
      },
      vsScoreResult: {
        type: Object
      }
    },
    computed: {
      homeTeamImage () {
        return _.get(this.vsScoreResult, 'homeTeamImg', '')
      },
      awayTeamImage () {
        return _.get(this.vsScoreResult, 'awayTeamImg', '')
      },
      homeTeamName () {
        return _.get(this.gameSummary, 'homeTeamName', '')
      },
      hHit () {
        return _.get(this.gameSummary, 'hHit', '')
      },
      hHr () {
        return _.get(this.gameSummary, 'hHr', '')
      },
      hSb () {
        return _.get(this.gameSummary, 'hSb', '')
      },
      hKk () {
        return _.get(this.gameSummary, 'hKk', '')
      },
      hGd () {
        return _.get(this.gameSummary, 'hGd', '')
      },
      hErr () {
        return _.get(this.gameSummary, 'hErr', '')
      },
      awayTeamName () {
        return _.get(this.gameSummary, 'awayTeamName', '')
      },
      aHit () {
        return _.get(this.gameSummary, 'aHit', '')
      },
      aHr () {
        return _.get(this.gameSummary, 'aHr', '')
      },
      aSb () {
        return _.get(this.gameSummary, 'aSb', '')
      },
      aKk () {
        return _.get(this.gameSummary, 'aKk', '')
      },
      aGd () {
        return _.get(this.gameSummary, 'aGd', '')
      },
      aErr () {
        return _.get(this.gameSummary, 'aErr', '')
      },
      textList () {
        const summaryText = _.get(this.gameSummary, 'text', '')
        return summaryText.split('||')
      }
    },
    methods: {
      graphPer (hNum, aNum) {
        return Number(hNum + aNum) === 0 ? 0 : (Number(hNum) * 100) / (Number(hNum) + Number(aNum))
      }
    }
  }
</script>
<style scoped>
  .team-comparison-wrap::after{
    content: '';
    display: table;
    clear: both;
  }

  .graph-wrap{
    font-size: 0;
  }

  .graph-wrap > span{
    display: inline-block;
    vertical-align: middle;
  }

  .graph-number{
    width: 50px;
    font-size: 16px;
    text-align: left;
  }

  .graph-outer{
    position: relative;
    width: calc(100% - 50px);
    height: 24px;
    background-color: #2f2f2f;
  }

  .graph-inner{
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    background-color: #ff5996;
  }

  .graph-away .graph-number{
    text-align: right;
  }

  .graph-away .graph-inner{
    right: auto;
    left: 0;
    background-color: #3887ff;
  }

  .kbo .result-content .team-comparison{
    margin-bottom: 16px;
  }

  .game-summary-area{
    margin-bottom: 69px;
  }

  .game-summary-area li{
    font-size: 16px;
    line-height: 32px;
    color: #a5a5a5;
  }
</style>
